<template>
    <div>
        <div class="head" style="display: flex;justify-content: space-between;">
            <el-breadcrumb style="margin-top: 10px ;margin-left:20px" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/processManager/contrac'}">承包商管理</el-breadcrumb-item>
                <el-breadcrumb-item>{{ $route.params.key ? "编辑" : "新增" }}</el-breadcrumb-item>
            </el-breadcrumb>
            <Button type="primary" @click="save()">保存</Button>
        </div>
        <div class="content">
            <template>
                <el-row>
                    <el-col :span="24">
                        <div class="grid-content bg-purple">
                            <div>
                                <div style="margin:auto;width: 1100px">
                                    <el-form :model="ruleForm" style="margin-top: 2%" :rules="rules"
                                             label-width="120px">
                                        <el-form-item label="名称" prop="contrName">
                                            <el-input v-model="ruleForm.contrName" style="width:750px"
                                                      size="small"></el-input>
                                        </el-form-item>
                                        <el-form-item label="社会信用代码" prop="creditCode">
                                            <el-input v-model="ruleForm.creditCode" style="width:750px"
                                                      size="small"></el-input>
                                        </el-form-item>
                                        <el-form-item label="单位性质" prop="contrNature">
                                            <el-input v-model="ruleForm.contrNature" style="width:750px"
                                                      size="small"></el-input>
                                        </el-form-item>
                                        <el-form-item label="承包商类别" prop="contrSort">
                                            <Select
                                                    v-model="ruleForm.contrSort"
                                                    filterable
                                                    style="width:750px"
                                                    placeholder="请选择"
                                            >
                                                <Option
                                                        v-for="item in types"
                                                        :key="item.id"
                                                        :label="item.name"
                                                        :value="item.id"
                                                ></Option>
                                            </Select>
                                        </el-form-item>
                                        <el-form-item label="承包商类型" prop="genre">
                                            <Select
                                                    v-model="ruleForm.genre"
                                                    filterable
                                                    style="width:750px;"
                                                    placeholder="请选择"
                                            >
                                                <Option
                                                        v-for="item in otherType"
                                                        :key="item.id"
                                                        :label="item.name"
                                                        :value="item.id"
                                                ></Option>
                                            </Select>
                                        </el-form-item>
                                        <el-form-item label="责任书到期时间" prop="duetime">
                                            <el-date-picker
                                                    v-model="ruleForm.duetime"
                                                    value-format="yyyy-MM-dd HH:mm:ss"
                                                    type="datetime" size="small"
                                                    placeholder="选择日期"
                                                    style="width:750px"
                                            ></el-date-picker>
                                        </el-form-item>
                                        <el-form-item label="经营范围" prop="contrScope">
                                            <el-input v-model="ruleForm.contrScope" size="small"
                                                      style="width:750px"></el-input>
                                        </el-form-item>
                                        <el-form-item label="承包商电话" prop="contrPhone">
                                            <el-input v-model="ruleForm.contrPhone" size="small"
                                                      style="width:750px"></el-input>
                                        </el-form-item>
                                        <el-form-item label="邮箱" prop="contrMail">
                                            <el-input v-model="ruleForm.contrMail" size="small"
                                                      style="width:750px"></el-input>
                                        </el-form-item>
                                        <el-form-item label="负责人" prop="chargerName">
                                            <el-input v-model="ruleForm.chargerName" size="small"
                                                      style="width:750px"></el-input>
                                        </el-form-item>
                                        <el-form-item label="安全负责人" prop="safetyCharger">
                                            <el-input v-model="ruleForm.safetyCharger" size="small"
                                                      style="width:750px"></el-input>
                                        </el-form-item>
                                        <el-form-item label="合作状态" prop="cooperationStatus">
                                            <el-input v-model="ruleForm.cooperationStatus" size="small"
                                                      style="width:750px"></el-input>
                                        </el-form-item>
                                        <el-form-item label="黑名单状态" prop="blackStatus">
                                            <Select
                                                    v-model="ruleForm.blackStatus"
                                                    filterable
                                                    style="width:750px"
                                                    placeholder="请选择"
                                            >
                                                <Option
                                                        v-for="item in blackStatus"
                                                        :key="item.id"
                                                        :label="item.name"
                                                        :value="item.id"
                                                ></Option>
                                            </Select>
                                        </el-form-item>
                                        <el-form-item label="资格证书编号" prop="certificateNo">
                                            <el-input v-model="ruleForm.certificateNo" size="small"
                                                      style="width:750px"></el-input>
                                        </el-form-item>
                                        <el-form-item label="资格证书" prop="jobs">
                                            <el-upload
                                                    class="upload-demo"
                                                    drag
                                                    multiple
                                                    action="/v1/lawsRegulations/uploadFile"
                                                    :limit="1"
                                                    :on-exceed="handleExceed"
                                                    :on-change="handleChange"
                                                    :file-list="fileList"
                                            >
                                                <i class="el-icon-upload"></i>
                                                <div class="el-upload__text">
                                                    将文件拖到此处，或
                                                    <em>点击上传</em>
                                                </div>
                                            </el-upload>
                                        </el-form-item>
                                        <el-form-item label="附件" prop="jobs">
                                            <el-upload
                                                    class="upload-demo"
                                                    drag
                                                    multiple
                                                    action="/v1/lawsRegulations/uploadFile"
                                                    :limit="1"
                                                    :on-exceed="handleExceed"
                                                    :on-change="handleChange2"
                                                    :file-list="fileList2"
                                            >
                                                <i class="el-icon-upload"></i>
                                                <div class="el-upload__text">
                                                    将文件拖到此处，或
                                                    <em>点击上传</em>
                                                </div>
                                            </el-upload>
                                        </el-form-item>
                                        <el-form-item label="通知人" prop="jobs">
                                            <Select
                                                    v-model="advice"
                                                    clearable
                                                    filterable
                                                    multiple
                                                    placeholder="请选择"
                                                    style="width:750px"
                                            >
                                                <Option
                                                        v-for="item in userData2"
                                                        :key="item.id"
                                                        :label="item.nickname"
                                                        :value="item.id"
                                                ></Option>
                                            </Select>
                                        </el-form-item>
                                    </el-form>
                                </div>
                                <!-- <el-divider direction="vertical" style="height: 600px"></el-divider> -->
                            </div>
                        </div>
                    </el-col>

                    <!-- <el-col :span="12">
                      <div class="grid-content bg-purple-light">
                        <div>
                          <div>
                            <span style="font-size: 19px">人员</span>
                          </div>
                          <div style="margin-top: 3%">
                            <template style="margin-top: 3%">
                              <el-transfer
                                :titles="['所有人员', '已选人员']"
                                filterable
                                :props="{
                                          key: 'id',
                                          label: 'name'
                                        }"
                                :right-default-checked="hasSelected"
                                :filter-method="filterMethod"
                                filter-placeholder="请输入搜索内容"
                                v-model="selectUser"
                                :data="userData"
                              ></el-transfer>
                            </template>
                          </div>
                        </div>
                        <el-divider></el-divider>
                        <div style="margin-top: 7%">
                          <div>
                            <span style="font-size: 19px">证书</span>
                            <Button type="primary" @click="showCer()" style="margin-left: 6%">新建证书</Button>
                          </div>

                          <div>
                            <el-table :data="cerDatas" style="width: 100%">
                              <el-table-column prop="employeeVo.name" label="拥有者"></el-table-column>
                              <el-table-column prop="certificateNo" label="证书编号">
                                <template slot-scope="scope">
                                  <a
                                    :download="scope.row.fileName"
                                    v-bind:href="scope.row.fileUrl"
                                  >{{scope.row.certificateNo}}</a>
                                </template>
                              </el-table-column>
                              <el-table-column prop="issuingAuthority" label="发证机关"></el-table-column>
                              <el-table-column prop="authorizeProject" label="作业项目"></el-table-column>
                              <el-table-column prop="certificateType" label="证件类型">
                              </el-table-column>
                              <el-table-column
                                prop="getCertificateTime"
                                label="领证日期"
                                :show-overflow-tooltip="true"
                              ></el-table-column>
                              <el-table-column prop="expireTime" label="有效期" :show-overflow-tooltip="true"></el-table-column>
                              <el-table-column
                                prop="nextReviewTime"
                                label="下次复审日期"
                                :show-overflow-tooltip="true"
                              ></el-table-column>
                            </el-table>
                          </div>
                        </div>
                      </div>
                    </el-col> -->
                </el-row>
            </template>
        </div>
        <Modal width="40" v-model="userIsShow" title="新增人员" @on-cancel="cancel">
            <div style="display: flex; width: 100%;margin: 10px auto;">
                <div
                        style="width: 100px;display: flex;
            									justify-content:flex-end; margin-right: 10px;"
                >
                    <span style="margin: auto 3px;color: red;">*</span>
                    <span style="margin: auto 0;">姓名:</span>
                </div>
                <Input placeholder="请输入姓名" v-model="addUserInfo.name"></Input>
            </div>
            <div style="display: flex; width: 100%;margin: 10px auto;">
                <div
                        style="width: 100px;display: flex;
            									justify-content:flex-end; margin-right: 10px;"
                >
                    <span style="margin: auto 0;">性别:</span>
                </div>
                <Select v-model="addUserInfo.sex">
                    <Option v-for="(option, index) in sexData" :value="option.id" :key="index">{{ option.name }}
                    </Option>
                </Select>
            </div>
            <div style="display: flex; width: 100%;margin: 10px auto;">
                <div
                        style="width: 100px;display: flex;
            									justify-content:flex-end; margin-right: 10px;"
                >
                    <span style="margin: auto 3px;color: red;">*</span>
                    <span style="margin: auto 0;">工号:</span>
                </div>
                <Input placeholder="请输入工号" v-model="addUserInfo.empNo"></Input>
            </div>

            <div style="display: flex; width: 100%;margin: 10px auto;">
                <div
                        style="width: 100px;display: flex;
            									justify-content:flex-end; margin-right: 10px;"
                >
                    <span style="margin: auto 3px;color: red;">*</span>
                    <span style="margin: auto 0;">定位设备编号:</span>
                </div>
                <Input placeholder="设备编号" v-model="addUserInfo.positioningDeviceNumber"></Input>
            </div>
            <div style="display: flex; width: 100%;margin: 10px auto;">
                <div
                        style="width: 100px;display: flex;
            									justify-content:flex-end; margin-right: 10px;"
                >
                    <span style="margin: auto 0;">头像:</span>
                </div>
                <el-upload
                        class="avatar-uploader"
                        action="/v1/employee/uploadImg"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        accept=".jpeg, .png"
                >
                    <img v-if="imageUrl" :src="host + imageUrl" class="avatar"/>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </div>

            <div slot="footer">
                <Button type="primary" style="margin-top: 10px;margin-bottom: 10px;" @click="addUser">保存</Button>
            </div>
        </Modal>
        <el-dialog title="新增证书" :visible.sync="cerIsShow" width="50%" :before-close="handleClose">
            <el-form
                    :model="addCerInfo"
                    label-width="100px"
                    class="demo-ruleForm"
                    style="width:60%;margin:0 auto"
            >
                <el-form-item label="拥有者" prop="name">
                    <el-select v-model="addCerInfo.ownerEmployeeId" placeholder="请选择">
                        <el-option
                                v-for="item in selectOnUser"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="证书编号" prop="jobs">
                    <el-input v-model="addCerInfo.certificateNo" style="width:500px"></el-input>
                </el-form-item>
                <el-form-item label="批准项目" prop="jobs">
                    <el-input v-model="addCerInfo.authorizeProject" style="width:500px"></el-input>
                </el-form-item>
                <el-form-item label="发证机关" prop="jobs">
                    <el-input v-model="addCerInfo.issuingAuthority" style="width:500px"></el-input>
                </el-form-item>
                <el-form-item label="领证日期" prop="jobs">
                    <el-date-picker
                            v-model="addCerInfo.getCertificateTime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetime"
                            placeholder="选择日期"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="到期日期" prop="jobs">
                    <el-date-picker
                            v-model="addCerInfo.expireTime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetime"
                            placeholder="选择日期"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="下次复审时间" prop="jobs">
                    <el-date-picker
                            v-model="addCerInfo.nextReviewTime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetime"
                            placeholder="选择日期"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="文件" prop="jobs">
                    <el-upload
                            class="upload-demo"
                            drag
                            action="/v1/certificate/uploadFile"
                            :on-change="handleChange3"
                            :file-list="fileList3"
                    >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">
                            将文件拖到此处，或
                            <em>点击上传</em>
                        </div>
                    </el-upload>
                </el-form-item>
                <el-form-item label="证书类别" prop="jobs">
                    <el-input v-model="addCerInfo.certificateType" style="width: 500px"
                              placeholder="请输入证书类型"></el-input>
                </el-form-item>
                <el-form-item label="通知人" prop="jobs">
                    <el-select v-model="advice2" clearable multiple placeholder="请选择">
                        <el-option
                                v-for="item in userData2"
                                :key="item.id"
                                :label="item.nickname"
                                :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <Button type="primary" style="margin-top: 10px;margin-bottom: 10px;" @click="submitCer">保存</Button>
            </div>
        </el-dialog>
        <!-- </Modal> -->
    </div>
</template>

<script>
    export default {
        data() {
            return {
                imageUrl: "",
                userData2: [], // 所有企业人员
                addCerInfo: {
                    ownerEmployeeId: "",
                    certificateNo: "",
                    authorizeProject: "",
                    issuingAuthority: "",
                    getCertificateTime: "",
                    expireTime: "",
                    nextReviewTime: "",
                    certificateType: ""
                },
                addUserInfo: {},
                sexData: [
                    {
                        id: 1,
                        name: "男"
                    },
                    {
                        id: 2,
                        name: "女"
                    },
                    {
                        id: 0,
                        name: "未知"
                    }
                ],
                cerDatas: [],
                cerIsShow: false,
                hasSelected: [], // 编辑的时候使用，初始化选中哪些
                advice: [],
                advice2: [],
                userIsShow: false,
                ruleForm: {},
                types: [
                    {name: "准承包商", id: 0},
                    {name: "合格承包商", id: 1},
                    {name: "不合格承包商", id: 2}
                ],
                otherType: [
                    {name: "环境改造", id: 0},
                    {name: "工程检修安装", id: 1},
                    {name: "建筑施工", id: 2},
                    {name: "吊装作业", id: 3},
                    {name: "其他", id: 4}
                ],
                blackStatus: [
                    {name: "否", id: 0},
                    {name: "是", id: 1}
                ],
                fileList: [],
                fileList2: [],
                fileList3: [],
                adviceUserData: [],
                userData: [], // 所有员工
                userData3: [],
                selectUser: [],
                selectOnUser: [],
                options: [
                    {
                        value: 0,
                        label: "特级证书"
                    },
                    {
                        value: 1,
                        label: "一级证书"
                    },
                    {
                        value: 2,
                        label: "二级证书"
                    },
                    {
                        value: 3,
                        label: "三级证书"
                    },
                    {
                        value: 4,
                        label: "四级证书"
                    },
                    {
                        value: 5,
                        label: "五级证书"
                    },
                    {
                        value: 6,
                        label: "六级证书"
                    }
                ],
                filterMethod(query, item) {
                    return item.name.indexOf(query) > -1;
                },
                isAdd: true,
                rules: {
                    contrName: [{required: true, message: '请输入名称'}],
                    contrSort: [{required: true, message: '请选择承包商类别'}],
                    contrPhone: [{required: true, message: '请输入电话'}],
                    duetime: [{required: true, message: '请选择责任书到期时间'}],
                    blackStatus: [{required: true, message: '请选择黑名单状态'}],
                    safetyCharger: [{required: true, message: '请输入安全负责人'}],
                    genre: [{required: true, message: '请选择承包商类型'}],
                    chargerName: [{required: true, message: '请输入负责人'}],
                    cooperationStatus: [{required: true, message: '请输入合作状态'}],
                    creditCode: [{required: true, message: '请输入社会信用代码'}],
                }
            };
        },
        mounted() {
            this.getAllUser();
            this.getUserData2();
        },
        methods: {
            showCer() {
                this.selectOnUser = [];
                this.addCerInfo = {};
                this.cerIsShow = true;
                if (this.selectUser.length > 0) {
                    for (var i = 0; i < this.userData.length; i++) {
                        if (this.selectUser.indexOf(this.userData[i].id) > -1) {
                            this.selectOnUser.push(this.userData[i]);
                        }
                    }
                    // console.log(this.selectOnUser);
                }
            },
            handleAvatarSuccess: function (res, file) {
                this.addUserInfo.image = res.data;
                this.imageUrl = res.data;
                // console.log(res);
                // console.log(this.addUserInfo);
            },
            addUser() {
                const that = this;
                let formdata = new FormData();
                formdata.append("name", this.addUserInfo.name);
                formdata.append("empNo", this.addUserInfo.empNo);
                formdata.append("sex", this.addUserInfo.sex);
                formdata.append("image", this.addUserInfo.image);
                formdata.append(
                    "positioningDeviceNumber",
                    this.addUserInfo.positioningDeviceNumber
                );
                this.componentsMoudel
                    .startPost("/employee/save", formdata, true)
                    .then(res => {
                        this.$message({
                            showClose: true,
                            message: "新增成功",
                            type: "success"
                        });

                        that.getAllUser();
                        that.userIsShow = false;
                    });
            },
            cancel() {
                this.userIsShow = false;
                this.cerIsShow = false;
                this.addCerInfo = {
                    ownerEmployeeId: "",
                    certificateNo: "",
                    authorizeProject: "",
                    issuingAuthority: "",
                    getCertificateTime: "",
                    expireTime: "",
                    nextReviewTime: "",
                    certificateType: ""
                };
            },
            handleClose() {
                this.userIsShow = false;
                this.cerIsShow = false;
                this.addCerInfo = {
                    ownerEmployeeId: "",
                    certificateNo: "",
                    authorizeProject: "",
                    issuingAuthority: "",
                    getCertificateTime: "",
                    expireTime: "",
                    nextReviewTime: "",
                    certificateType: ""
                };
            },
            getAllUser() {
                this.componentsMoudel.httpRequest
                    .getRequestHander(
                        this.componentsMoudel.getData("urls").getAllEmployeeList
                    )
                    .openLoad()
                    .startGet()
                    .then(res => {
                        this.userData = res.body.data;
                        this.userData3 = res.body.data;
                    });
            },
            handleChange(file, fileList) {
                this.fileList = fileList.slice(-3);
                // console.log(this.fileList)
            },
            handleChange2(file, fileList) {
                this.fileList2 = fileList.slice(-3);
            },
            handleChange3(file, fileList) {
                this.fileList3 = fileList.slice(-3);
            },
            // 超出文件限制个数的事件
            handleExceed(files, fileList) {
                this.$message.warning(
                    `当前限制选择 1 个文件`
                );
            },
            save() {
                let url = "";
                if (this.isAdd) {
                    url = "/contractorInfo/save";
                } else {
                    url = "/contractorInfo/update";
                }
                if (this.fileList.length > 0) {
                    let trainStuffDtos = [];
                    for (let item in this.fileList) {
                        let fileInfo = {};
                        fileInfo.fileName = this.fileList[item].name;
                        fileInfo.url = this.fileList[item].response.data;
                        trainStuffDtos.push(fileInfo);
                    }
                    // this.ruleForm.certificateStr = trainStuffDtos;
                    this.ruleForm.certificateStr = JSON.stringify(trainStuffDtos);
                }
                if (this.ruleForm.certificateStr == "null") {
                    this.ruleForm.certificateStr = '[]';
                }
                if (this.fileList2.length > 0) {
                    let trainStuffDtos = [];
                    for (let item in this.fileList2) {
                        var fileInfo = {};
                        fileInfo.fileName = this.fileList2[item].name;
                        fileInfo.url = this.fileList2[item].response.data;
                        trainStuffDtos.push(fileInfo);
                    }
                    this.ruleForm.attachmentsStr = JSON.stringify(trainStuffDtos);
                }
                if (this.ruleForm.attachmentsStr == "null") {
                    this.ruleForm.attachmentsStr = '[]';
                }
                this.ruleForm.alertOthersIds = JSON.stringify(this.advice);
                // console.log(this.selectUser)
                if (this.selectUser.length > 0) {
                    let arr1 = this.selectUser;
                    let arr2 = arr1;
                    for (let k in arr2) {
                        if (!arr2[k]) {
                            arr1.splice(k, 1);
                        }
                    }
                    // console.log(arr1)
                    this.ruleForm.employeesIds = arr1.join(",");
                }

                let cerDataIds = [];
                // console.log(this.ruleForm)
                if (this.cerDatas) {
                    for (var i = 0; i < this.cerDatas.length; i++) {
                        var cerDatum = this.cerDatas[i].id;
                        cerDataIds.push(cerDatum);
                    }
                }
                this.ruleForm.certificates = JSON.stringify(cerDataIds);
                // console.log(this.ruleForm)
                this.componentsMoudel.httpRequest
                    .getRequestHander(url)
                    .openLoad()
                    .startPost(this.ruleForm)
                    .then(res => {
                        this.$message({
                            showClose: true,
                            message: "操作成功",
                            type: "success"
                        });
                        this.$router.push({
                            path: "/processManager/contrac"
                        });
                    });
            },
            getUserData2() {
                this.componentsMoudel.httpRequest
                    .getRequestHander(this.componentsMoudel.getData("urls").getAllUser)
                    .openLoad()
                    .startGet()
                    .then(res => {
                        this.userData2 = res.body.data;
                    });
            },
            getDataInfo(id) {
                this.componentsMoudel.httpRequest
                    .getRequestHander("/contractorInfo/info/" + id)
                    .openLoad()
                    .startGet()
                    .then(res => {
                        this.ruleForm = res.body.data;
                        if (!this.ruleForm.certificateVos) {
                            this.ruleForm.certificateVos = [];
                        }
                        // console.log(this.ruleForm.certificateVo)
                        let files = JSON.parse(this.ruleForm.certificateStr);
                        this.advice = JSON.parse(this.ruleForm.alertOthersIds);
                        if (this.ruleForm.employeeVos.length > 0) {
                            for (var j = 0; j < this.ruleForm.employeeVos.length; j++) {
                                var iElement = this.ruleForm.employeeVos[j].id;
                                this.selectUser.push(iElement);
                            }
                        }
                        if (files) {
                            for (let i = 0; i < files.length; i++) {
                                let myFile = {};
                                let file = files[i];
                                myFile.response = {};
                                myFile.response.data = file.url;
                                myFile.name = file.fileName;
                                this.fileList.push(myFile);
                            }
                        }
                        let files1 = JSON.parse(this.ruleForm.attachmentsStr);
                        if (files1) {
                            for (let i = 0; i < files1.length; i++) {
                                let myFile = {};
                                let file = files1[i];
                                myFile.response = {};
                                myFile.response.data = file.url;
                                myFile.name = file.fileName;
                                this.fileList2.push(myFile);
                            }
                        }
                        this.cerDatas = this.ruleForm.certificateVos;
                    });
            },
            submitCer() {
                let url = this.componentsMoudel.getData("urls").saveCertificate;
                if (this.fileList3.length > 0) {
                    this.addCerInfo.fileName = this.fileList3[0].name;
                    this.addCerInfo.fileUrl = this.fileList3[0].response.data;
                }
                this.addCerInfo.alertOthersIds = JSON.stringify(this.advice2);
                this.componentsMoudel.httpRequest
                    .getRequestHander(url)
                    .openLoad()
                    .startPost(this.addCerInfo)
                    .then(res => {
                        this.$message({
                            showClose: true,
                            message: "操作成功",
                            type: "success"
                        });
                        // console.log(res)
                        let arr8 = this.cerDatas;
                        // this.cerDatas = []
                        let obj = res.body.data;
                        obj.employeeVo = {name: ""};
                        // console.log("人员数组",  this.userData3)
                        for (let m in this.userData3) {
                            if (this.userData3[m].id === obj.ownerEmployeeId) {
                                // console.log('判断')
                                let str = this.userData3[m];
                                // console.log(this.userData3[m])
                                obj.employeeVo.name = str.name;
                            }
                        }
                        // console.log("push数据" , obj)
                        // console.log(this.cerDatas)
                        arr8.push(obj);
                        this.cerDatas = arr8;
                        this.cerIsShow = false;
                    });
            }
        },
        created() {
            let obj = this.$route.params.key;
            if (this.$route.params.key) {
                this.isAdd = false;
                this.getDataInfo(obj.id);
                // this.ruleForm = obj;
            } else {
                this.ruleForm = {};
            }
        },
        deactivated() { //路由组件失活时时执行函数
            this.$destroy() //路由组件失活时 销毁组件 再次打开重载组件
        }
    };
</script>

<style scoped>
    .el-divider--vertical {
        display: inline-block;
        width: 1px;
        height: 100em;
        margin: 0 8px;
        vertical-align: middle;
        position: relative;
    }

    .el-transfer-panel {
        border: 1px solid #ebeef5;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        display: inline-block;
        vertical-align: middle;
        width: 248px;
        max-height: 100%;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        position: relative;
    }

    .el-transfer-panel__list.is-filterable {
        height: 400px;
    }
</style>
